// extracted by mini-css-extract-plugin
export default {"cardsSection":"styles_cardsSection__mE3yT","cardsSection__roundsWrapper":"styles_cardsSection__roundsWrapper__npOP+"};